const TravelIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_15964_89372)">
      <path
        d="M0.167699 31.5976C0.342573 31.8494 0.63001 32.0004 0.937635 32.0004H31.0623C31.3699 32.0004 31.6574 31.8494 31.8323 31.5976C32.008 31.3449 32.0483 31.0227 31.9403 30.7343C31.575 29.7574 30.8921 28.9005 30.6146 28.5782C30.437 28.3704 30.177 28.2505 29.9033 28.2505H2.09669C1.82295 28.2505 1.56295 28.3704 1.38532 28.5782C1.10795 28.9005 0.424948 29.7574 0.0596363 30.7343C-0.0483635 31.0227 -0.00811359 31.3449 0.167699 31.5976Z"
        fill="white"
      />
      <path d="M3.75 15.0625H9.4375V26.375H3.75V15.0625Z" fill="white" />
      <path d="M13.1875 15.0625H18.8125V26.375H13.1875V15.0625Z" fill="white" />
      <path d="M22.5625 15.0625H28.25V26.375H22.5625V15.0625Z" fill="white" />
      <path
        d="M2.02918 12.9119C2.20518 13.0886 2.45012 13.188 2.69237 13.188C2.69249 13.188 2.69268 13.1879 2.69281 13.1879C2.69293 13.1879 2.69312 13.188 2.69324 13.1874H29.3067C29.3068 13.188 29.307 13.1879 29.3071 13.1879C29.3073 13.1879 29.3074 13.188 29.3076 13.188C29.5498 13.188 29.7948 13.0887 29.9708 12.9119C30.1615 12.7212 31.5871 11.2365 31.9999 9.43799H0C0.412812 11.2365 1.83837 12.7212 2.02918 12.9119Z"
        fill="white"
      />
      <path
        d="M31.4004 7.56297L16.4164 0.0993477C16.1527 -0.0324648 15.8414 -0.0324648 15.5778 0.0993477L0.59375 7.56297H31.4004Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_15964_89372">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default TravelIcon
